import React, { ReactNode } from "react";
import ZigButton, { ZigButtonGroup, ZigButtonProps } from "../ZigButton";
import ZigTypography from "../../display/ZigTypography";
import { Box } from "@mui/system";
import { ErrorMessage } from "../../display/ZigAlertMessage";

const ZigButtonGroupInput = ({
  value,
  label,
  error,
  options,
  onChange,
  prefixId,
}: {
  value: string;
  options: {
    id?: string;
    value: string;
    label: string | ReactNode;
    tooltip?: string;
    hidden?: boolean;
    extraProps?: ZigButtonProps;
  }[];
  error?: string | ReactNode;
  label?: string | ReactNode;
  prefixId?: string;
  onChange: (value: string) => void;
}) => {
  return (
    <>
      {typeof label === "string" && (
        <Box sx={{ mb: 1.25 }}>
          <ZigTypography variant="body1" color="neutral200" id={prefixId && `${prefixId}__label`}>
            {label}
          </ZigTypography>
        </Box>
      )}

      {!!label && typeof label !== "string" && label}

      <ZigButtonGroup>
        {options.map((o) => {
          if (o.hidden) return null;
          return (
            <ZigButton
              id={o.id}
              onClick={() => onChange(o.value)}
              key={o.value}
              active={value === o.value || undefined}
              variant={"outlined"}
              {...(o.extraProps || {})}
            >
              {o.label}
            </ZigButton>
          );
        })}
      </ZigButtonGroup>

      {!!error && (
        <Box sx={{ marginTop: "3px" }}>
          <ErrorMessage text={error} />
        </Box>
      )}
    </>
  );
};

export default ZigButtonGroupInput;
